import React, { PropsWithChildren } from "react";
import {
    Badge,
    Card,
    Col,
    Form,
    InputGroup,
    ListGroup,
    Row,
} from "react-bootstrap";
import { FiSearch } from "react-icons/fi";

type PanelProps = PropsWithChildren<{
    title: string;
    count: number;
    searchPlaceholder: string;
    searchValue: string;
    onSearchChange: (value: string) => void;
    searchTestId?: string;
    listTestId?: string;
    emptyText: string;
    isEmpty: boolean;
}>;

const AssignListPanel: React.FC<PanelProps> = ({
    title,
    count,
    searchPlaceholder,
    searchValue,
    onSearchChange,
    searchTestId,
    listTestId,
    emptyText,
    isEmpty,
    children,
}) => (
    <Card className="border-0 shadow-sm h-100">
        <Card.Header className="bg-white d-flex align-items-center justify-content-between">
            <span className="fw-semibold">
                {title}{" "}
                <Badge bg="light" text="dark">
                    {count}
                </Badge>
            </span>
        </Card.Header>
        <Card.Body className="pt-2">
            <InputGroup className="mb-2">
                <InputGroup.Text>
                    <FiSearch />
                </InputGroup.Text>
                <Form.Control
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(e) => onSearchChange(e.target.value)}
                    data-testid={searchTestId}
                />
            </InputGroup>
            <ListGroup className="assign-modal-list" data-testid={listTestId}>
                {isEmpty ? (
                    <div className="text-muted small p-3">{emptyText}</div>
                ) : (
                    children
                )}
            </ListGroup>
        </Card.Body>
    </Card>
);

type Props = {
    availableTitle: string;
    assignedTitle: string;
    availableCount: number;
    assignedCount: number;
    availableSearchPlaceholder: string;
    assignedSearchPlaceholder: string;
    availableSearch: string;
    assignedSearch: string;
    onAvailableSearchChange: (value: string) => void;
    onAssignedSearchChange: (value: string) => void;
    availableSearchTestId?: string;
    assignedSearchTestId?: string;
    availableListTestId?: string;
    assignedListTestId?: string;
    availableEmptyText: string;
    assignedEmptyText: string;
    availableItems: React.ReactNode;
    assignedItems: React.ReactNode;
    availableIsEmpty: boolean;
    assignedIsEmpty: boolean;
};

const AssignDualListPanels: React.FC<Props> = ({
    availableTitle,
    assignedTitle,
    availableCount,
    assignedCount,
    availableSearchPlaceholder,
    assignedSearchPlaceholder,
    availableSearch,
    assignedSearch,
    onAvailableSearchChange,
    onAssignedSearchChange,
    availableSearchTestId,
    assignedSearchTestId,
    availableListTestId,
    assignedListTestId,
    availableEmptyText,
    assignedEmptyText,
    availableItems,
    assignedItems,
    availableIsEmpty,
    assignedIsEmpty,
}) => (
    <Row className="g-3">
        <Col xs={12} md={6}>
            <AssignListPanel
                title={availableTitle}
                count={availableCount}
                searchPlaceholder={availableSearchPlaceholder}
                searchValue={availableSearch}
                onSearchChange={onAvailableSearchChange}
                searchTestId={availableSearchTestId}
                listTestId={availableListTestId}
                emptyText={availableEmptyText}
                isEmpty={availableIsEmpty}
            >
                {availableItems}
            </AssignListPanel>
        </Col>
        <Col xs={12} md={6}>
            <AssignListPanel
                title={assignedTitle}
                count={assignedCount}
                searchPlaceholder={assignedSearchPlaceholder}
                searchValue={assignedSearch}
                onSearchChange={onAssignedSearchChange}
                searchTestId={assignedSearchTestId}
                listTestId={assignedListTestId}
                emptyText={assignedEmptyText}
                isEmpty={assignedIsEmpty}
            >
                {assignedItems}
            </AssignListPanel>
        </Col>
    </Row>
);

export default AssignDualListPanels;
